module.exports = {
      id: "islide-banner-left-en-usage",
      viewBox: "0 0 500 250",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#islide-banner-left-en-usage",
      toString: function () {
        return this.url;
      }
    }